import { I18nLegacy, String } from "@silvertours/front-legacy-shared";
import { useFormatter, useTranslations } from "next-intl";
var hosts = {
    de: "billiger-mietwagen.de",
    fr: "carigami.fr"
};
export var useReviewItem = function(item) {
    var aggregateRating = item.aggregateRating, date = item.date, locationName = item.locationName, providerQuote = item.providerQuote, reviewerName = item.reviewerName;
    var ratingFormatOptions = {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    };
    var important = I18nLegacy.important;
    var format = useFormatter();
    var language = I18nLegacy.useLocale().language;
    var t = useTranslations("features.trustLegacy.feedback.reviewItem");
    var dateLabel = String.useRelativeDate(date);
    var host = hosts[language];
    var ratingLabel = t.rich("ratingLabel", {
        rating: format.number(aggregateRating, ratingFormatOptions),
        important: important
    });
    var ratingLocation = t.rich("ratingLocation", {
        location: locationName,
        important: important
    });
    var reviewerLabel = t("reviewerLabel", {
        reviewerName: reviewerName
    });
    var providersQuoteTitleLabel = t("providersQuoteTitleLabel", {
        organizers: providerQuote.organizers,
        rentalCompanies: providerQuote.rentalCompanies
    });
    var siteQuoteTitleLabel = t("siteQuoteTitleLabel", {
        host: host
    });
    return {
        host: host,
        providersQuoteTitleLabel: providersQuoteTitleLabel,
        reviewerLabel: reviewerLabel,
        siteQuoteTitleLabel: siteQuoteTitleLabel,
        header: {
            aggregateRating: aggregateRating,
            dateLabel: dateLabel,
            ratingLabel: ratingLabel,
            locationName: locationName,
            ratingLocation: ratingLocation
        }
    };
};
